import React from 'react';
import './Button.css';

function Button({ text, type, onClickHandler, state }) {
    let disabled = '';
    if (state === 'disabled') {
        disabled = 'button-disabled';
    }
    return (
        <button className={`button ${type} ${disabled}`} type="button" onClick={onClickHandler}>
            { text }
        </button>
    );
}

export default Button;
